import {resourcesPath} from '@/settings'

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 *
 * @param iconPath
 * @returns {*|string}
 */
export function convertPath(iconPath) {
    return validUrl(iconPath) ? iconPath : resourcesPath + iconPath
}

/**
 * 校验ul
 * @author zhangzhipeng
 * @param url
 * @returns {boolean}
 */
export function validUrl(url) {
    return /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
    return true
}
